// ===============================
// Active menu header local
// ===============================

var headerLocal = $('.header-local');

if (headerLocal.length) {
    document.addEventListener('scroll', function () {

        if (!headerLocal[0].getBoundingClientRect().top) headerLocal.addClass('is-sticky');else headerLocal.removeClass('is-sticky');
    }); 
}

if (headerLocal.length) {
    $('.site-header').addClass('relative');
    var headerLocalBurger = $('.header-local__burger');
    var headerLocalNav = $('.header-local__nav');
    var headerLocalNavDropdown = $('.header-local__nav .is-dropdown');
    var headerLocalNavDropdownItem = $('.header-local__nav .is-dropdown span');
    
    headerLocalBurger.on('click', function () {
        headerLocalBurger.toggleClass('is-show');
        headerLocalNav.slideToggle();
    });
    
    headerLocalNavDropdownItem.on('click', function () {
        headerLocalNavDropdown.toggleClass('is-show');
        $(this).parent().find('ul').slideToggle();
    });
}